<template>
  <div class="main-body">
    <div id="farmerMachineMap"></div>
  </div>
</template>
<script>
import L from 'leaflet'
import config from '@/config/defaultSettings'
import weihaiGeoJson from '@/assets/geoJson/371000_full.json'
import 'leaflet.chinatmsproviders'
import 'leaflet/dist/leaflet.css'
import 'leaflet-search'
import 'leaflet-search/src/leaflet-search.css'
import { MatchineMap } from '@/api/main/FarmMachineJobManage'
import '@/assets/awesome-markers/dist/leaflet.awesome-markers.css'
import '@/assets/awesome-markers/dist/leaflet.awesome-markers.js'
export default {
  name: 'FarmerMachineMap',
  data() {
    return {
      center: [37.513153, 122.120769],
      markers: [],
      orgId: null
    }
  },
  methods: {
    searchByAjax(text, callResponse) {
      setTimeout(() => {
        const data = [
          {
            loc: [41.507149, 13.172994],
            title: 'chocolate'
          },
          {
            loc: [41.847149, 14.132994],
            title: 'coral'
          },
          {
            loc: [41.21919, 13.062145],
            title: 'cyan'
          }
        ]
        callResponse(data)
      }, 2000)
    },
    initMap() {
      const normalm = L.tileLayer.chinaProvider('TianDiTu.Normal.Map', {
        maxZoom: 18,
        minZoom: 5,
        key: config.tiandituKey
      })
      const normala = L.tileLayer.chinaProvider('TianDiTu.Normal.Annotion', {
        maxZoom: 18,
        minZoom: 5,
        key: config.tiandituKey
      })
      const imgm = L.tileLayer.chinaProvider('TianDiTu.Satellite.Map', {
        maxZoom: 18,
        minZoom: 5,
        key: config.tiandituKey
      })
      const imga = L.tileLayer.chinaProvider('TianDiTu.Satellite.Annotion', {
        maxZoom: 18,
        minZoom: 5,
        key: config.tiandituKey
      })
      const terrainm = L.tileLayer.chinaProvider('TianDiTu.Terrain.Map', {
        maxZoom: 18,
        minZoom: 5,
        key: config.tiandituKey
      })
      const terraina = L.tileLayer.chinaProvider('TianDiTu.Terrain.Annotion', {
        maxZoom: 18,
        minZoom: 5,
        key: config.tiandituKey
      })

      const normal = L.layerGroup([normalm, normala])
      const image = L.layerGroup([imgm, imga])
      const terrain = L.layerGroup([terrainm, terraina])
      const outline = L.geoJson(weihaiGeoJson, {
        style: function() {
          return {
            color: '#ffff00',
            opacity: 1,
            fillColor: '#0000ff',
            fillOpacity: 0.05
          }
        }
      })
      const baseLayers = {
        地图: normal,
        影像: image,
        地形: terrain
      }
      const overlayLayers = {
        轮廓: outline
      }

      this.map = L.map('farmerMachineMap', {
        layers: [normal],
        center: this.center,
        zoom: 15,
        zoomControl: true,
        doubleClickZoom: true,
        attributionControl: false
      })

      this.map.addControl(
        new L.Control.Search({
          position: 'topleft',
          zoom: 12,
          // marker: true,
          sourceData: this.searchByAjax,
          markerLocation: true
        })
      )

      L.control
        .layers(baseLayers, overlayLayers, {
          position: 'topright',
          collapsed: true
        })
        .addTo(this.map)
      this.loadData()
    },
    loadData() {
      if (this.orgId) {
        MatchineMap({ orgId: this.orgId }).then(res => {
          const color = ['red', 'darkred', 'orange', 'green', 'darkgreen', 'blue', 'purple', 'darkpurple', 'cadetblue']
          const markerIcon = L.AwesomeMarkers.icon({
            prefix: 'icon',
            extraClasses: 'iconfont',
            icon: 'wuxing',
            markerColor: color[Math.floor(Math.random() * color.length)]
          })
          if (res.success) {
            res.data.forEach(item => {
              let content = '<div style="width:200px;font-size:14px">'
              content += `<div style="font-size:18px; font-weight: bold;">${item.orgName}</div>`
              content += `<div style="padding-top: 15px;"><span style="font-weight: bold;">农机数量：</span>${item.mct}</div>`
              content += `<div style="padding-top: 5px;"><span style="font-weight: bold;">作业面积：</span>${item.area}</div>`
              content += `<div style="padding-top: 5px;"><span style="font-weight: bold;">作业总额：</span>${item.totalamount}</div>`
              content += `</div>`

              this.markers.push(
                L.marker(JSON.parse(item.latlng), { icon: markerIcon })
                  .bindPopup(content, { autoClose: false, closeOnClick: false })
                  .openPopup()
              )
            })
            const machineLayer = L.layerGroup(this.markers)
            this.map.addLayer(machineLayer)
          } else {
            console.log(res)
          }
        })
      }
    }
  },
  mounted() {
    this.orgId = this.$route.params.orgId
    this.initMap()
  }
}
</script>
<style scoped>
.main-body {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}
.leaflet-marker-icon {
  background-image: url(https://cdn.jsdelivr.net/npm/leaflet@1.7.1/dist/images/marker-icon.png);
}
#farmerMachineMap {
  width: 100%;
  height: calc(100vh);
  height: 100%;
  z-index: 1;
  position: relative;
}

.leaflet-right .leaflet-control {
  position: relative;
  right: -5px;
}
.ant-modal-body {
  padding: 0px;
}
.ant-modal {
  padding-bottom: 0px;
}
</style>
